export const DASHBOARD_ROUTE = 'DASHBOARD_ROUTE';
export const LOGIN_ROUTE = 'LOGIN_ROUTE';
export const SIGNUP_ROUTE = 'SIGNUP_ROUTE';
export const FORGOT_PASSWORD_ROUTE = 'FORGOT_PASSWORD_ROUTE';
export const RESET_PASSWORD_ROUTE = 'RESET_PASSWORD_ROUTE';
export const PROFILE_GENERAL_ROUTE = 'PROFILE_GENERAL_ROUTE';
export const PROFILE_PAYROLL_ROUTE = 'PROFILE_PAYROLL_ROUTE';
export const PROFILE_ALLOWANCE_ROUTE = 'PROFILE_ALLOWANCE_ROUTE';
export const PROFILE_LEAVE_ROUTE = 'PROFILE_LEAVE_ROUTE';
export const PROFILE_OVERTIME_ROUTE = 'PROFILE_OVERTIME_ROUTE';
export const PROFILE_ATTENDANCE_ROUTE = 'PROFILE_ATTENDANCE_ROUTE';
export const REGISTER_EMPLOYEE_ROUTE = 'REGISTER_EMPLOYEE_ROUTE';
export const EMPLOYEES_ROUTE = 'EMPLOYEES_ROUTE';
export const EMPLOYEE_GENERAL_ROUTE = 'EMPLOYEE_GENERAL_ROUTE';
export const EMPLOYEE_PAYROLL_ROUTE = 'EMPLOYEE_PAYROLL_ROUTE';
export const EMPLOYEE_PAYROLL_SALARY_ROUTE = 'EMPLOYEE_PAYROLL_SALARY_ROUTE';
export const EMPLOYEE_PAYROLL_COMPONENT_ROUTE = 'EMPLOYEE_PAYROLL_COMPONENT_ROUTE';
export const EMPLOYEE_PROMOTION_HISTORY_ROUTE = 'EMPLOYEE_PROMOTION_HISTORY_ROUTE';
export const EMPLOYEE_PAYROLL_DETAILS_ROUTE = 'EMPLOYEE_PAYROLL_DETAILS_ROUTE';
export const EMPLOYEE_ALLOWANCE_ROUTE = 'EMPLOYEE_ALLOWANCE_ROUTE';
export const EMPLOYEE_LEAVE_ROUTE = 'EMPLOYEE_LEAVE_ROUTE';
export const EMPLOYEE_OVERTIME_ROUTE = 'EMPLOYEE_OVERTIME_ROUTE';
export const EMPLOYEE_ATTENDANCE_ROUTE = 'EMPLOYEE_ATTENDANCE_ROUTE';
export const EMPLOYEE_CONTRACTS_ROUTE = 'EMPLOYEE_CONTRACTS_ROUTE';
export const EMPLOYEE_DOCUMENT_ROUTE = 'EMPLOYEE_DOCUMENT_ROUTE';
export const EMPLOYEE_SETTINGS_ROUTE = 'EMPLOYEE_SETTINGS_ROUTE';
export const EMPLOYEE_ACTIVITY_ROUTE = 'EMPLOYEE_ACTIVITY_ROUTE';
export const EMPLOYEE_OFFBOARDING_ROUTE = 'EMPLOYEE_OFFBOARDING_ROUTE';
export const PAYROLL_ROUTE = 'PAYROLL_ROUTE';
export const PAYROLL_SETTINGS_ROUTE = 'PAYROLL_SETTINGS_ROUTE';
export const PAYROLL_SUMMARY_ROUTE = 'PAYROLL_SUMMARY_ROUTE';
export const PAYROLL_DETAILS_ROUTE = 'PAYROLL_DETAILS_ROUTE';
export const PAYROLL_SLIP_ROUTE = 'PAYROLL_SLIP_ROUTE';
export const LEAVES_ROUTE = 'LEAVES_ROUTE';
export const HOLIDAYS_ROUTE = 'HOLIDAYS_ROUTE';
export const LEAVE_TYPES_ROUTE = 'LEAVE_TYPES_ROUTE';
export const ATTENDANCE_ROUTE = 'ATTENDANCE_ROUTE';
export const ATTENDANCE_SETTING_ROUTE = 'ATTENDANCE_SETTING_ROUTE';
export const OVERTIME_ROUTE = 'OVERTIME_ROUTE';
export const RECRUITMENT_ROUTE = 'RECRUITMENT_ROUTE';
export const ADD_JOB_POST_ROUTE = 'ADD_JOB_POST_ROUTE';
export const EDIT_JOB_POST_ROUTE = 'EDIT_JOB_POST_ROUTE';
export const JOB_POST_DETAILS_ROUTE = 'JOB_POST_DETAILS_ROUTE';
export const JOB_APPLICATIONS_ROUTE = 'JOB_APPLICATIONS_ROUTE';
export const PUBLIC_JOB_APPLICATION_ROUTE = 'PUBLIC_JOB_APPLICATION_ROUTE';
export const ORGANIZATION_STRUCTURE_ROUTE = 'ORGANIZATION_STRUCTURE_ROUTE';
export const GENERAL_SETTINGS_ROUTE = 'GENERAL_SETTINGS_ROUTE';
export const SECURITY_SETTINGS_ROUTE = 'SECURITY_SETTINGS_ROUTE';
export const CALENDAR_SETTINGS_ROUTE = 'CALENDAR_SETTINGS_ROUTE';
export const EXPORT_TEMPLATES_ROUTE = 'EXPORT_TEMPLATES_ROUTE';
export const CREATE_EXPORT_TEMPLATE_ROUTE = 'CREATE_EXPORT_TEMPLATE_ROUTE';
export const EDIT_EXPORT_TEMPLATE_ROUTE = 'EDIT_EXPORT_TEMPLATE_ROUTE';
export const PROVACY_POLICY_ROUTE = 'PROVACY_POLICY_ROUTE';
export const PROJECTS_ROUTE = 'PROJECTS_ROUTE';
export const PROJECT_DETAILS_ROUTE = 'PROJECT_DETAILS_ROUTE';
export const REPORTS_ROUTE = 'REPORTS_ROUTE';
export const REPORT_BUILDER_ROUTE = 'REPORT_BUILDER_ROUTE';
export const OFFBOARDING_SETTINGS_ROUTE = 'OFFBOARDING_SETTINGS_ROUTE';
export const KNOWLEDGE_BASE_ROUTE = 'KNOWLEDGE_BASE_ROUTE';
export const KNOWLEDGE_BASE_ARTICLE_ROUTE = 'KNOWLEDGE_BASE_ARTICLE_ROUTE';export const HELP_CENTER_ROUTE = 'HELP_CENTER_ROUTE';
export const HELP_SECTION_ROUTE = 'HELP_SECTION_ROUTE';
export const HELP_ARTICLE_ROUTE = 'HELP_ARTICLE_ROUTE';
export const CHAT_ROUTE = 'CHAT_ROUTE';
export const CHAT_CONVERSATION_ROUTE = 'CHAT_CONVERSATION_ROUTE';
export const FILES_ROUTE = 'FILES_ROUTE';
export const FILES_FOLDER_ROUTE = 'FILES_FOLDER_ROUTE';
